<app-supplier-auction-offer-list-ssy1280detail
  [state]="viewState.Details"></app-supplier-auction-offer-list-ssy1280detail>
